import SectionHeading from "@/components/SectionHeading";
import { StaggerGroup, StaggerItem } from "@/components/motion";
import { CREDIBILITY } from "@/data/site";

export default function Credibility() {
  return (
    <section data-testid="credibility" className="bg-white py-8">
      <div className="nc-container">
        <SectionHeading
          eyebrow="Founding Team — Combined Track Record"
          title="Built by a founding team who've been inside the hiring room."
          subtitle="North Cadence was founded by two executives whose combined careers span global enterprise sales, IT staffing and consulting, healthcare SaaS product leadership, and AI. The credibility behind this firm is grounded in real careers — not invented numbers."
        />

        <StaggerGroup className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {CREDIBILITY.map((c) => (
            <StaggerItem key={c.label}>
              <div className="h-full rounded-3xl border border-[#e7e9ef] bg-[#FEF7F2] p-7">
                <p className="font-display text-2xl font-bold text-[#142A5E]">{c.label}</p>
                <p className="mt-2 text-[15px] leading-relaxed text-[#1B1B1B]/60">{c.desc}</p>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
}
